module.exports = __webpack_public_path__ + "static/media/parceiro-sensedia-07.1ec6b56d.jp2";